<template>
  <div>
    <anchor-tooltip-btn
      small
      left
      is-icon
      id="approve-reject-file-btn"
      icon="mdi-contrast-box"
      tooltip="Approve/Reject"
      color="primary"
      :disabled="disabled"
      @click="modal = true"
    />
    <anchor-approve-reject-modal
      v-if="modal"
      v-model="modal"
      :title="`Approve/Reject File - ${file.filename}`"
      :rules="rules"
      :options="options"
      :loading="loading"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import AnchorTooltipBtn from '../buttons/TooltipBtn';

export default {
  name: 'AnchorApproveRejectFile',
  components: {
    AnchorTooltipBtn,
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
      default: true,
    },
    file: {
      type: Object,
      required: true,
    },
    rules: {
      type: Object,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modal: false,
      loading: false,
    };
  },
  methods: {
    handleSubmit(model) {
      const newModel = model;
      newModel.file = this.file;
      this.$emit('submit', newModel, this);
    },
  },
};
</script>
